const _inFlight = new Map<string, Promise<unknown>>();

export function dedupFetch<T>(key: string, fetcher: () => Promise<T>): Promise<T> {
  if (_inFlight.has(key)) {
    return _inFlight.get(key) as Promise<T>;
  }
  const promise = fetcher().finally(() => {
    _inFlight.delete(key);
  });
  _inFlight.set(key, promise);
  return promise;
}
